import axios from 'axios';
import { apiConfig } from 'src/config';

export const getSingleContent = async (payload) => {
  return axios
    .get(
      apiConfig.APP_BASE_URL +
        'public/api/v1/content/preview/' +
        payload.content_id
    )
    .then((res) => {
      return res.data;
    })
    .catch((error) => {
      throw error;
    });
};
